<template>
  <Navbar />
  <ScrollButton />

<section
    class="banner-title"
    style="background-image: url(images/whatwedo.png)"
  >
    <div class="auto-container">
      <div class="row clearfix">
        <div class="title-column col-md-6 col-sm-6 col-xs-12">
          <h1>Ne Yapıyoruz</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <ul class="bread-crumb clearfix">
            <li>
              <a href="#">Anasayfa</a>
            </li>
            <li class="active">Ne Yapıyoruz</li>
          </ul>
        </div>
        <!-- Col end -->
      </div>
      <!-- Row end -->
    </div>
    <!-- Banner text end -->
  </section>

  <section class="page-container">
    <div class="auto-container">
      <div class="text-content">
        <div class="left-text">
            <blockquote>
                    <p>
                      Elektronik ve otomasyon sektöründeki projelerimizle, mekanik sistemlere
                      hareket kabiliyeti ve otonom işlev kazandırıyor, teknolojiyi en üst düzeyde uyguluyoruz.
                    </p>

                    <p class="mt-2">
                      Elektronik dizgi, kablo gruplama, montaj ve test makineleriyle yüksek üretim kapasitemizi
                      kalite odaklı bir stratejiyle birleştiriyor; her zaman güvenilir ve kaliteli ürünler sunmayı önceliklendiriyoruz.
                    </p>

                    <p class="mt-4">
                      <strong>Araştırıyoruz:</strong> Sektördeki teknolojik gelişmeleri yakından takip ediyor,
                      sürekli araştırma yaparak müşterilerimize en güncel çözümleri sunuyoruz.
                    </p>

                    <p>
                      <strong>Geliştiriyoruz:</strong> İnovatif yaklaşımımız ve mühendislik gücümüzle,
                      ürün ve hizmetlerimizi sürekli geliştiriyor, sektörün ihtiyaçlarına özel çözümler üretiyoruz.
                    </p>

                    <p>
                      <strong>Üretiyoruz:</strong> Modern üretim altyapımız sayesinde,
                      en yüksek kalitede ürünleri kendi tesisimizde üretiyoruz.
                    </p>

                    <p class="mt-4">
                      Mekanik ve elektromekanik sistemleri en verimli şekilde yöneten,
                      hareket kabiliyeti kazandıran, izlenebilirlik ve uzaktan kontrol imkânı sağlayan teknolojiler
                      geliştiriyor ve müşterilerimize entegre çözümler olarak sunuyoruz.
                    </p>
          </blockquote>
        </div>
        <div class="right-img">
                  <img
                    src="images/whatwedo.jpeg"
                    class="whatwedo-img"
                    alt="İntek Electronics üretim faaliyeti"
                    loading="lazy"
                  />
                </div>
      </div>
    </div>
  </section>

  <Footer />
</template>

<script setup>
import { useHead } from '@vueuse/head';
import Navbar from '@/components/Navbar-2.vue';
import ScrollButton from '@/components/ScrollButton.vue';
import Footer from '@/components/Footer.vue';

useHead({
  title: 'Ne Yapıyoruz - İntek Electronic | Elektronik Üretim ve Otomasyon',
  meta: [
    {
      name: 'description',
      content: 'İntek Electronic olarak elektronik üretim, otomasyon çözümleri, kablo gruplama, test ve montaj sistemleri geliştiriyoruz. Yenilikçi ve güvenilir teknolojilerle sektöre yön veriyoruz.'
    },
    {
      name: 'keywords',
      content: 'intek, elektronik üretim, otomasyon, test sistemleri, kablo gruplama, kontrol kartı üretimi, intek elektronik, elektromekanik, pcb dizgi, AR-GE'
    },
    {
      property: 'og:title',
      content: 'Ne Yapıyoruz - İntek Electronic'
    },
    {
      property: 'og:description',
      content: 'Elektronik üretim ve otomasyon teknolojileriyle sektöre yön veren çözümler geliştiriyoruz.'
    },
    {
      property: 'og:image',
      content: 'https://www.intekelectronic.com.tr/images/whatwedo.jpeg'
    }
  ]
});
</script>

<style scoped>
.text-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 40px;
}

.left-text {
  flex: 1 1 400px;
}

.right-img {
  flex: 1 1 320px;
  display: flex;
  justify-content: center;
}

.whatwedo-img {
  width: 100%;
  max-width: 460px;
  height: auto;
  border-radius: 8px;
}
/* Mobil uyum */
@media (max-width: 768px) {
  .text-content {
    flex-direction: column;
    align-items: center;
    text-align: left;
  }
}
</style>
